import "./footer.css";
import { useSettings } from "../../context/SettingsContext";
import { ReactComponent as Logo } from "../../assets/images/main-logo-03.svg";
import momo from "../../assets/images/icons/momo.png";
import mbbank from "../../assets/images/icons/mbbank.png";
import vietcombank from "../../assets/images/icons/vietcombank.png";
import techcombank from "../../assets/images/icons/techcombank.png";
import visa from "../../assets/images/icons/visa.png";
import paypal from "../../assets/images/icons/paypal.png";
import { DmcaBadge } from "./DmcaBadge";

const BANK_METHOD = [momo, mbbank, vietcombank, techcombank, visa, paypal];
const Footer = () => {
  const { settings } = useSettings();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Brand */}
        <div className="footer-links">
          <Logo className="footer-logo"></Logo>
          <ul>
            <li><a href="/about-us">Giới thiệu</a></li>
            <li><a href="/term-of-service">Điều khoản dịch vụ</a></li>
            <li><a href="/privacy-policy">Chính sách bảo mật</a></li>
          </ul>
        </div>

        {/* Column 2: Navigation */}
        <div className="footer-links">
          <h3>Hỗ trợ</h3>
          <ul>
            <li><a href={settings?.contact_messenger_url || "https://messenger.me"} target="_blank" rel="noopener noreferrer">
              Liên hệ qua Messenger
            </a></li>
            <li><a href={settings?.contact_zalo_url || "https://zalo.me"} target="_blank" rel="noopener noreferrer">
            Liên hệ qua Zalo
            </a></li>
          </ul>

        </div>
        {/* Column 3: Contact */}
        <div className="footer-contact">
          <h3>Phương thức thanh toán</h3>
          <div className="banking-container">
            {BANK_METHOD.map(bank => (
              <div key={bank} className="grid-item">
                <img src={bank} alt="Bank Image" />
              </div>
            ))}
          </div>
        </div>


        {/* Column 4: Social Media */}
        <div className="footer-social">
          <h3>Theo dõi chúng tôi trên</h3>
          <div className="social-icons">
            <a href={settings?.facebook_url || "https://iampesmobile.com"}><i className="fab fa-facebook-f"></i></a>
            <a href={settings?.tiktok_url || "https://www.tiktok.com/@iampesmobile"}>
              <i className="fab fa-tiktok"></i>
            </a>
            <a href={settings?.youtube_url || "https://www.youtube.com/@iampesmobile"}>
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      <div>
        <DmcaBadge/>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; 2025 iampesmobile.com, all rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
